import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { ReactComponent as RulerIcon } from '@/assets/ruler_grey.svg';

export const Wrapper = styled(Flex)`
  align-items: center;
  gap: ${px2rem(5)};
  margin: ${({ theme }) => theme.spacing(3, 1, 0, 0)};
`;

export const Container = styled(Flex)`
  flex-direction: column;
  min-width: 100px;
  ${({ theme }) => theme.media.md.up} {
    width: 140px;
  }
`;

export const Ruler = styled(RulerIcon)`
  width: 24px;
  min-width: ${px2rem(24)};

  &:hover {
    cursor: pointer;
  }
`;

export const StrapSizeNotSelectedError = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.error};
  `}
`;
